import React, { useEffect, useRef, useState } from "react";
import Button from "components/UI/Button/Button";

import styles from "components/Form/FormDropdown/FormDropdown.module.scss";

const FormDropdown = ({ items = [], itemClickHandler, visible }) => {

  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(visible);

  useEffect(() => {
    setIsVisible(visible);
  }, [visible]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!isVisible || items.length === 0) return null;

  return (
    <div
      ref={containerRef}
      className={styles.container}
      onMouseLeave={() => {
        setTimeout(() => setIsVisible(false), 200);
      }}
    >
      <ul className={styles.list}>
        {items.map((item, idx) => {
          return (
            <li key={`dropdown-item-${idx}`}>
              <Button type="button" onClick={() => itemClickHandler(item)}>
                {item?.["name"] || item?.["number"]}
              </Button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FormDropdown;
